import homePromo from './home-promo.png'

export default (): React.ReactElement => (
  <img style={{ maxWidth: '100%', width: '780px', height: 'auto' }} src={homePromo} alt="clanzy home" />
)
